import { render, staticRenderFns } from "./customer-editor.vue?vue&type=template&id=4b46a1a2&scoped=true&"
import script from "./customer-editor.vue?vue&type=script&lang=js&"
export * from "./customer-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b46a1a2",
  null
  
)

export default component.exports